<template>
    <div>
        <div class="card mb-2">
            <div class="card-body">
                <p v-if="!edit">{{comment.comment}}</p>
                <div v-else>
                    <textarea class="form-control" v-model="text"></textarea>
                    <button class="mt-2 btn btn-success" @click="editComment">Speichern</button>
                </div>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col-6">
                        <span class="font-10">{{comment.datetime_comment}}</span>
                    </div>
                    <div class="col-6 text-right">
                        <div class="btn-group">
                            <button class="btn btn-secondary btn-sm" @click="edit = true">
                                <font-awesome-icon icon="edit"/>
                            </button>
                            <button class="btn btn-danger btn-sm" @click="deleteComment">
                                <font-awesome-icon icon="trash-alt"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                text: this.comment.comment,
                edit: false
            }
        },
        props: [ 'comment' ],
        methods: {
            deleteComment() {
                this.$bvModal.msgBoxConfirm('Möchten Sie diesen Kommentar wirklich löschen?', {
                    okVariant: 'danger',
                    okTitle: 'Löschen',
                    cancelTitle: 'Abbrechen'
                }).then(val => {
                    if(val) {
                        this.$store.state.loading = true;
                        let res = null;

                        this.$http.delete('/queryApi/deleteQueryComment?id=' + this.comment.id).then(response => {
                          this.$emit('delete');
                          res = response.data;
                        }).catch(error => {
                            console.log(error);
                        }).then(() => {
                            this.$store.state.loading = false;
                            this.$bvToast.toast(res, {
                                variant: 'success'
                            });
                        });
                    }
                });
            },
            editComment() {
                if(this.text != ''){
                    this.$store.state.loading = true;

                    this.$http.put('/queryApi/editQueryComment?id=' + this.comment.id, {
                        comment: this.text
                    }).then(response => {
                        this.$bvToast.toast(response.data, {
                            title: 'Benachrichtigung',
                            variant: 'success'
                        });
                        this.comment.comment = this.text;
                    }).catch(error => {
                        console.log(error);
                    }).then(() => {
                        this.$store.state.loading = false;
                    });
                    this.edit = false;
                }else {
                    this.$bvToast.toast('Der Kommentar kann nicht leer sein!', {
                        title: 'Fehler',
                        variant: 'danger'
                    });
                }
            }
        }
    }
</script>

<style scoped>
textarea{
    resize: none;
    width: 100%;
    height: 200px;
}
</style>
